import { render, staticRenderFns } from "./Tablets.vue?vue&type=template&id=6762948a&scoped=true"
import script from "./Tablets.vue?vue&type=script&lang=js"
export * from "./Tablets.vue?vue&type=script&lang=js"
import style0 from "./Tablets.vue?vue&type=style&index=0&id=6762948a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6762948a",
  null
  
)

export default component.exports